import { UAContext } from '@quentin-sommer/react-useragent';
import React, { ReactNode, useContext } from 'react';
import StatusButton from '~components/navigation-panel/status-button';
import Typography from '~components/typography';
import { useTranslation } from '~i18n';

export type Status = 'success' | 'pending' | 'todo' | 'complete' | 'error' | 'warning' | 'grey';

interface ISectionCardProps {
  title: ReactNode;
  status?: Status | null | undefined;
  statusText?: string | null;
  style?: any;
  wrapperStyle?: any;
  subTitle?: ReactNode;
  subTitleStyle?: any;
  onSubTitleClick?: () => void;
  onRightActionClick?: () => void;
  actionText?: ReactNode;
}
export const SectionCard: React.FC<ISectionCardProps> = props => {
  const uaResults = useContext(UAContext).uaResults as UAResults;
  const isMobile = uaResults.mobile;
  const { t } = useTranslation(['student_portal']);

  const {
    title,
    status,
    statusText,
    style,
    wrapperStyle,
    subTitle,
    actionText,
    onSubTitleClick,
    onRightActionClick,
  } = props;
  return (
    <div className="section-card" style={{ ...wrapperStyle }}>
      <div className="section-card__title" style={{ ...style }}>
        <div className="section-card__title-label"></div>
        <Typography variant={isMobile ? 'h8' : 'h7'}>{title}</Typography>
        {subTitle && (
          <Typography
            variant="body3"
            textDecoration="underline"
            cursor="pointer"
            style={{ marginLeft: 12 }}
            onClick={() => {
              if (onSubTitleClick) onSubTitleClick();
            }}
          >
            {subTitle}
          </Typography>
        )}
        {status && statusText && (
          <StatusButton name={statusText} status={status} className={`section-card__status-icon`} />
        )}
        {onRightActionClick && (
          <Typography
            variant="body3"
            cursor="pointer"
            style={{ marginLeft: 12 }}
            color="var(--color-green_7)"
            className="section-card__action"
            onClick={() => onRightActionClick()}
          >
            +{' '}
            <Typography variant="body3" textDecoration="underline">
              {actionText || t('my_stay.add')}
            </Typography>
          </Typography>
        )}
      </div>
      {props.children}
      <style jsx>
        {`
          .section-card {
            width: 100%;
            &__title {
              display: flex;
              align-items: center;
            }
            &__title-label {
              width: 4px;
              height: 16px;
              background: var(--color-red_6);
              margin-right: 8px;
            }
            :global(&__status-icon) {
              margin-left: 8px;
            }
            :global(&__action) {
              flex: 1;
              text-align: right;
            }
          }

          @media screen and (max-width: 768px) {
            .section-card {
              &__title {
                display: flex;
                align-items: center;
              }
              &__title-label {
                height: 14px;
              }
            }
          }
        `}
      </style>
    </div>
  );
};
